function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.8 10c-.1-.2-.3-.4-.5-.4h-2.4V3.3c0-.3-.2-.6-.6-.6H9.1c-.3.1-.5.3-.5.6v1.2c0 .3.2.6.6.6s.6-.2.6-.6v-.6h15.1v8.4l-1.4 1.1V6.1c0-.3-.2-.6-.6-.6H6.6c-.3 0-.6.2-.6.6v1.2c0 .3.2.6.6.6s.6-.2.6-.6v-.6h15.1v7.6l-1.4 1.1V8.9c0-.3-.2-.6-.6-.6H4.1c-.3 0-.6.2-.6.6v7.4l-2.5 2c-.2.1-.3.4-.2.6.1.2.3.4.5.4h2.2v7.5c0 .3.2.6.6.6h16.2c.3 0 .6-.2.6-.6v-9.9l1.4-1.1v7.7h-.4c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.9c.3 0 .6-.2.6-.6v-9.2l1.4-1.1v7h-.4c-.3 0-.6.2-.6.6 0 .3.2.6.6.6h.9c.3 0 .6-.2.6-.6V13l2.7-2.2c.2-.3.2-.5.2-.8zm-9-.6v6.9l-2.4 1.9H4.6V9.4h15.2zM2.9 18.2l.6-.5v.5h-.6zm16.9 8H4.6v-6.9h12.9c.1 0 .2 0 .3-.1l1.8-1.5v8.5zm6.1-14.8v-.6h.8l-.8.6z"
})));